/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_Deal_CreateInputs */

const cs_audit_key_deal_create = /** @type {(inputs: Audit_Key_Deal_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod vytvořen`)
};

const en_audit_key_deal_create = /** @type {(inputs: Audit_Key_Deal_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal created`)
};

/**
* | output |
* | --- |
* | "Deal created" |
*
* @param {Audit_Key_Deal_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_deal_create = /** @type {((inputs?: Audit_Key_Deal_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_Deal_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_deal_create(inputs)
	return cs_audit_key_deal_create(inputs)
});